/* istanbul ignore file */
import { toast } from "@arionbanki/arionui";
import { useEffect, useState } from "react"

/**
 * A custom hook for utulizing a countdown
 * @param time The time (in seconds) that the countdown should take
 * @param finish An optional callback function to execute when countdown finishes
 * @param startNow Determines whether the countdown should start immiediately. Default is true.
 * @returns state as number, indicating the remaining seconds
 * @returns a void function for initiating or restarting the countdown
 */
export function useCountdown(time: number, finish: () => any = () => '', startNow = true): { countdown: number, startTime: () => void } {
    const [countdown, setCountdown] = useState(startNow ? time : 0);
    const [started, setStarted] = useState(startNow);
    useEffect(() => {
        if (countdown <= 0 && started) {
            finish();
        } else if (started) {
            setTimeout(() => {
                setCountdown(countdown - 1);
            }, 1000);
        } else {
            return
        }
    }, [countdown])

    const startTime = () => {
        setCountdown(time);
        setStarted(true);
    }

    return { countdown, startTime }
}

/**
 * A custom hook for listening for any errors that may occur
 * @param condition What condition triggers the error if true
 * @param message What message should the user receive
 * @param header What is the title of the error - default "An error has occured"
 */
export function useErrorAlert(condition: boolean, message: string, header: string = "An error has occured"): void {
    useEffect(() => {
        if (condition) {
            toast.error(message, header)
        }
    }, [condition])
}